import React from "react";
import styled from "styled-components";

import { cloud } from "@vitalsource/vstui/colors";
import Bookshelf1 from "./bookshelf1";
import Bookshelf2 from "./bookshelf2";
import Bookshelf3 from "./bookshelf3";
import Bookshelf4 from "./bookshelf4";
import CircleComplete from "./circle-complete";
import CircleIncomplete from "./circle-incomplete";

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  opacity: ${({ count }) => (count >= 2 ? 0 : 1)};
  transition: opacity 1500ms;
`;

const Checkmarks = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 407px;
  margin-top: 20px;
`;

const Divider = styled.div`
  width: 80;
  height: 2;
  background: ${cloud.getShade(4)};
`;

const CatLoader = ({ count }) => (
  <Container count={count}>
    {count === 0 && <Bookshelf2 />}
    {count === 1 && <Bookshelf3 />}
    {count === 2 && <Bookshelf4 />}
    {count === 3 && <Bookshelf4 />}
    <Checkmarks>
      {count >= 0 ? <CircleComplete /> : <CircleIncomplete />}
      <Divider />
      {count >= 1 ? <CircleComplete /> : <CircleIncomplete />}
      <Divider />
      {count >= 2 ? <CircleComplete /> : <CircleIncomplete />}
    </Checkmarks>
  </Container>
);

export default CatLoader;
